import { TargetSelector, getColorSelector } from "@client/selectors";
import * as React from "react";
import { createSelector } from "reselect";

export const makeIconStyleSelector = () => {
  const colorSelector = getColorSelector(TargetSelector.Entity, "iconCustomColor");

  return createSelector(
    [colorSelector],
    (color): React.CSSProperties => ({
      color
    })
  );
};
